import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Box from '../base/Box'
import { Card, CardActions, CardHeader, CardContent } from '../base/Card'
import Grid from '../base/Grid'
import Typography from '../base/Typography'
import IconButton from '../button/IconButton'
import TextField from '../input/Input'

export interface CardNoteClientData {
  id: number
  author?: string
  description?: string
  date?: string
}

export type CardNoteClientProps = {
  note: CardNoteClientData
  isEdit: boolean
  onDelete(id: number): void
  onEdit(id: number): void
  onCancel(id: number): void
  onSave(id: number): void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      borderRadius: 8,
      width: 404
    },
    header: {
      padding: 0,
      marginBottom: theme.spacing(1)
    },
    content: {
      padding: 0,
      marginBottom: theme.spacing(1)
    },
    actions: {
      padding: 0,
      color: theme.palette.grey[800]
    },
    btnIconTrash: {
      marginLeft: theme.spacing(1)
    },
    displayHide: {
      display: 'none'
    }
  })
)

const NoteClientCard: React.FC<CardNoteClientProps> = (props) => {
  const { note, isEdit, onDelete, onEdit, onCancel, onSave, ...rest } = props
  const classes = useStyles()
  return (
    <Card classes={{ root: classes.root }} {...rest}>
      <CardHeader
        className={classes.header}
        headTitle={
          <Typography bodyVariants="xxsMedium" children={`By ${note.author}`} />
        }
      />
      <CardContent className={classes.content}>
        <Typography
          className={isEdit ? classes.displayHide : ''}
          variant="caption"
          children={note.description}
        />
        <TextField
          fullWidth
          className={isEdit ? '' : classes.displayHide}
          multiline
          value={note.description}
        />
      </CardContent>
      <CardActions className={classes.actions}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="caption" children={note.date} />
          <Box display={isEdit ? 'none' : 'block'}>
            <IconButton
              onClick={(): void => onEdit(note.id)}
              iconName="EditsIcon"
              size="small"
              iconSize="small"
            />
            <IconButton
              onClick={(): void => onDelete(note.id)}
              className={classes.btnIconTrash}
              iconName="TrashIcon"
              size="small"
              iconSize="small"
            />
          </Box>
          <Box display={isEdit ? 'block' : 'none'}>
            <IconButton
              onClick={(): void => onSave(note.id)}
              iconName="TickIcon"
              size="small"
              iconSize="small"
            />
            <IconButton
              onClick={(): void => onCancel(note.id)}
              className={classes.btnIconTrash}
              iconName="CloseIcon"
              size="small"
              iconSize="small"
            />
          </Box>
        </Grid>
      </CardActions>
    </Card>
  )
}

export default NoteClientCard
